var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noResult-warp"},[_c('div',{staticClass:"noResult-box"},[_c('img',{attrs:{"src":_vm.noResultImg}}),_vm._v(" "),_c('div',{staticClass:"noResult-tip"},[_vm._v("暂无相关记录")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bc6473","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noPaymentList.vue
// module id = null
// module chunks = 